/// <amd-module name="Widgets/CumulativeFlowDiagram/QueryUtilities" />
import { WidgetPresentationMode } from "Dashboards/WidgetContracts/WidgetProps";

export const widgetCommand = "CFD";
export const reportCommand = "CFDReport";
export function getCommandName(presentationMode?: WidgetPresentationMode): string {
    return presentationMode && presentationMode === WidgetPresentationMode.embeddedView ? reportCommand : widgetCommand;
}
